export default __webpack_public_path__ + "/images/ukraine-flag.jpg";